export default __webpack_public_path__ + "static/Soltera_Video-c17047a5eaacb36a77e78e96612fe021.mp4";